import { LOAD_SUCCESS } from '../constants';

export const notificationReducer = (state, action) => {
  const {
    type,
    payload: { notification, page, pagination },
  } = action;

  switch (type) {
    case LOAD_SUCCESS:
      return {
        ...state,
        notificationLoading: false,
        notification:
          page === 1 ? notification : [...state.notification, ...notification],
        pagination,
      };

    default:
      return state;
  }
};
